export default __webpack_public_path__ + "static/media/roadmapv2b.9820622a.jpg";